import * as React from 'react';

import {
  ApButtonMain,
  ApButtonSecondary,
  // ApModal,
} from '@alixpartners/ui-components';

import {
  InputModalContent,
  InputModalFooter,
  StyledApModal,
} from './ConfirmationModal.styles';

interface IConfirmModalProps {
  header: string;
  confirmText: string;
  isOpen: boolean;
  onModalClose: () => void;
  onConfirm: () => void;
}

export const ConfirmationModal: React.FC<IConfirmModalProps> = ({
  isOpen,
  header,
  onModalClose,
  onConfirm,
  confirmText,
}) => {
  return (
    <StyledApModal
      header={header || 'Confirm action'}
      isOpen={isOpen}
      hasClosed={onModalClose}
      footer={() => (
        <InputModalFooter>
          <ApButtonMain
            onClick={() => {
              onConfirm();
              onModalClose();
            }}
            disabled={false}
          >
            Confirm
          </ApButtonMain>
          <ApButtonSecondary onClick={onModalClose}>Cancel</ApButtonSecondary>
        </InputModalFooter>
      )}
    >
      <InputModalContent>{confirmText}</InputModalContent>
    </StyledApModal>
  );
};
